import './style.css'
import * as THREE from 'three'
import { GUI } from 'dat.gui'
import Stats from 'three/examples/jsm/libs/stats.module'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import VertexShader from './shaders/vertexshader.glsl';
import FragmentShader from './shaders/fragmentshader.glsl';

/**
 * Base
 */
// Canvas
const canvas = document.querySelector('canvas.webgl')

// Scene
const scene = new THREE.Scene()

/**
 * Stats
 */
 const stats = Stats()
 document.body.appendChild(stats.dom)

/**
 * Sizes
 */
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

window.addEventListener('resize', () =>
{
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

/**
 * Mouse move
 */
let mouse = new THREE.Vector2();
window.addEventListener('mousemove', (event) => {
    event.preventDefault();
    mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
    mouse.y = - (event.clientY / window.innerHeight) * 2 + 1;

    mesh.position.x = mouse.x;
    mesh.position.y = mouse.y;

})

window.addEventListener('scroll', (event) => {
    console.log(window.scrollY);
    mesh.rotation.x = -window.scrollY * 0.1;
})

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height, 0.1, 100)
camera.position.z = 1
scene.add(camera)

/**
 * Lights
 */
 const light = new THREE.AmbientLight( 0x404040 ); // soft white light
 scene.add( light ); 
 const directionalLight = new THREE.DirectionalLight( 0xffffff, 1.0 );
 scene.add( directionalLight );

// Controls
// const controls = new OrbitControls(camera, canvas)
// controls.enableDamping = true

/**
 * Geometry
 */
 const geometry = new THREE.SphereGeometry(1.0, 512, 512);


/**
 * Material
 */
const material = new THREE.ShaderMaterial({
    uniforms: {
        uTime: {value: 0},
        uDistortionFrequency: {value: 1.31},
        uDistortionStrength: {value: 0.494},
        uDisplacementFrequency: {value: 2.0},
        uDisplacementStrength: {value: 0.141}
    },
    vertexShader: VertexShader,
    fragmentShader: FragmentShader
});


/**
 * Mesh
 */
const mesh = new THREE.Mesh(geometry, material)
scene.add(mesh)

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
    canvas: canvas,
    antialias: true,
})
renderer.setSize(sizes.width, sizes.height)
renderer.setClearColor(0xffffff, 1)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

/**
 * Dat gui
 */
 const gui = new GUI();
 const noisegui = gui.addFolder("Noise");
 noisegui.add(material.uniforms.uDistortionFrequency, 'value', 0.0, 2.0).step(0.001).name("Distortion Frequency");
 noisegui.add(material.uniforms.uDistortionStrength, 'value', 0.0, 0.9).step(0.001).name("Distortion Strength");
 noisegui.add(material.uniforms.uDisplacementFrequency, 'value', 0.0, 2.0).step(0.001).name("Displacement Frequency");
 noisegui.add(material.uniforms.uDisplacementStrength, 'value', 0.0, 0.1).step(0.001).name("Displacement Strength");


/**
 * Animate
 */
const clock = new THREE.Clock()
let lastElapsedTime = 0

const tick = () =>
{
    const elapsedTime = clock.getElapsedTime()
    const deltaTime = elapsedTime - lastElapsedTime
    lastElapsedTime = elapsedTime

    // Update controls
    // controls.update()

    // Update stats
    stats.update()

    material.uniforms.uTime.value = elapsedTime

    // Render
    renderer.render(scene, camera)

    // Call tick again on the next frame
    window.requestAnimationFrame(tick)
}

tick()